module.exports = __webpack_public_path__ + "img/symbol_17.e6e90f51.png";